import React from 'react';

const View = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 14" {...props}>
    <path
      fillRule="evenodd"
      d="M11.994 9a2 2 0 1 0 0-3.999 2 2 0 0 0 0 3.999m0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0 1c3.925 0 7.296-1.823 9.588-5-2.292-3.177-5.663-5-9.588-5-3.925 0-7.296 1.823-9.588 5 2.292 3.177 5.663 5 9.588 5m0 2C7.153 14 3.006 11.61.356 7.546L0 7l.356-.546C3.006 2.39 7.153 0 11.994 0c4.84 0 8.988 2.39 11.638 6.454l.356.546-.356.546C20.982 11.61 16.835 14 11.994 14"
    />
  </svg>
);

export default View;
